/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/research_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M7 20h16v.5H7zM8 9h4v6H8zM8 16h4v1H8zM9 17.5h2V19H9zM9 4h2v4.5H9zM19 18h4v1h-4zM20 24a2 2 0 012-2c.366 0 .705.105 1 .277V21h-4v4h1.277A1.974 1.974 0 0120 24z"/><path pid="1" d="M19 6c-3.663 0-6 3.554-6 6v3h2v-3c0-1.41 1.519-4 4-4s4 2.59 4 4v10.277c.596.347 1 .985 1 1.723s-.404 1.376-1 1.722V27h2V12c0-2.446-2.337-6-6-6z"/><path pid="2" d="M22 26a1.993 1.993 0 01-1.723-1H11l-2 2h14v-1.277A1.977 1.977 0 0122 26z"/><circle pid="3" cx="22" cy="24" r="1"/><path pid="4" d="M8.5 32H0v-8.5h1V31h7.5zM14.269 31h3.461v1h-3.461zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.27 0h3.461v1H14.27zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
